import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AppService } from '../../../../../services/app.service';

@Component({
  selector: 'kt-historique-adresse',
  templateUrl: './adresse-dialog.component.html',
  styleUrls: ['./adresse-dialog.component.scss']
})
export class AdresseHistoriqueDialogComponent implements OnInit {
  dossier: any[];
  adresses: any[];
  current:  any
  constructor(
    public dialogRef: MatDialogRef<AdresseHistoriqueDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService : AppService
  ) { }

  ngOnInit() {
     console.log(" AdresseHistoriqueDialogComponent dossier ",this.data);
    if (this.data
	      && this.data.dossier!=undefined
	      && this.data.dossier.tiers!=undefined) {
		  if(
	     this.data.dossier.tiers.adresses_historique!=undefined
	     )
	    {
		  this.adresses=this.data.dossier.tiers.adresses_historique;
		    console.log(" AdresseHistoriqueDialogComponent dossier ", this.adresses);
		}
		
		if( this.data.dossier.tiers.adresses!=undefined
			&& this.data.dossier.tiers.adresses.PRINCIPALE!=undefined
		    )
		   {
			this.current=this.data.dossier.tiers.adresses.PRINCIPALE;
		}
	}	
	
  }

}
